import React, { useState } from 'react';
import { Box, Typography, Modal, Card, CardContent, List, ListItem, ListItemIcon,
   ListItemText, useTheme, useMediaQuery, Button } from '@mui/material';
import { CheckCircle, Info, ArrowForward } from '@mui/icons-material';
import HireTech from './hiretechhomepage';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OrganizationsHeader from '../dashboardnavebar';
import DownloadProjects from "../DownloadProject";

const OrganizationsHiretech = () => {
  const theme = useTheme();
  const isTabletOrBelow = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  const brochureName = "techtalentHiringRequirementTemplate.pdf";

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="students-flex">
      <OrganizationsHeader />
     <Box 
      sx={{
        background: 'linear-gradient(to right, #e0f7fa, #f1f8e9)',
        blockSize: isTabletOrBelow ? 'auto' : '91vh',
        overflowY: isTabletOrBelow ? 'visible' : 'auto',
        padding: isTabletOrBelow ? '10px' : '20px',
      }}>
      {/* Top-right Button */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpen}
          sx={{ textTransform: 'none' }}
        >
          Download Opportunity Submission Template
        </Button>
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          background: 'linear-gradient(to right, #e0f7fa, #f1f8e9)',
          display: 'flex',
          flexDirection: isTabletOrBelow ? 'column' : 'row',
          justifyContent: 'center',
          alignItems: 'flex-start',
          overflowY: isTabletOrBelow ? 'visible' : 'auto',
          padding: isTabletOrBelow ? '10px' : '40px',
          gap: 4,
        }}
      >
        <Box>
          <HireTech />
        </Box>
      </Box>

      {/* Popup Modal */}
      <Modal open={open} onClose={handleClose} scroll="body">
     <Box
        sx={{
          position: 'absolute',
          top : '50%',
          left : '50%',
          transform: 'translate(-50%, -50%)',
          width : '90%',
          maxWidth : 600,
          maxHeight : '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 2,
          borderRadius: 2,
          outline: 'none',
          overflowY: 'auto',
        }}
        >
        {/* Close Icon */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top : 8,
            right : 8,
            color: 'grey.600',
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" fontWeight="bold" gutterBottom color="#043885">
          Simplify Your Internship & Job Postings
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          To streamline the process of sharing your internship or job openings on Huebits, we've provided a structured template.
        </Typography>

        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Why Use This Template?
            </Typography>
            <List dense>
              <ListItem>
                <ListItemIcon><CheckCircle color="primary" /></ListItemIcon>
                <ListItemText primary="Efficiently gather and organize all necessary details." />
              </ListItem>
              <ListItem>
                <ListItemIcon><CheckCircle color="primary" /></ListItemIcon>
                <ListItemText primary="Clearly communicate expectations, required skills, and timelines." />
              </ListItem>
              <ListItem>
                <ListItemIcon><CheckCircle color="primary" /></ListItemIcon>
                <ListItemText primary="Facilitate quicker evaluations and postings on Huebits." />
              </ListItem>
            </List>
          </CardContent>
        </Card>

        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              Guidelines:
            </Typography>
            <List dense>
              <ListItem>
                <ListItemIcon><Info color="warning" /></ListItemIcon>
                <ListItemText primary="All fields in the form are mandatory." />
              </ListItem>
              <ListItem>
                <ListItemIcon><Info color="warning" /></ListItemIcon>
                <ListItemText primary="If a section doesn't apply, you may leave it blank." />
              </ListItem>
            </List>
          </CardContent>
        </Card>

        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          Get Started:
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <ArrowForward fontSize="small" sx={{ mr: 1 }} />
          <DownloadProjects brochureName={brochureName} /> and fill in the required information.
        </Typography>
        <Typography variant="body2">
          Let's collaborate to empower innovation through industry partnerships!
        </Typography>
      </Box>
      </Modal>
      </Box>
    </div>
  );
};

export default OrganizationsHiretech;
